//// filepath: /home/admin/web/new.avelonpr.com/avelon-frontend/src/components/global/ScrollToTop.tsx
"use client";
import React, { useState, useEffect } from "react";
import styles from "./css/ScrollToTop.module.css";

const ScrollToTop: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [chatVisible, setChatVisible] = useState(false);

  // Toggle visibility of the button based on scroll position
  const toggleVisible = () => {
    if (window.pageYOffset > 250) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  };

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Detect scroll position
  useEffect(() => {
    window.addEventListener("scroll", toggleVisible);
    return () => window.removeEventListener("scroll", toggleVisible);
  }, []);

  // Detect Tawk.to chat widget presence
  useEffect(() => {
    const checkChatPresence = () => {
      // Check for Tawk.to iframe or container (adjust selector as needed)
      const tawkWidget = document.querySelector("#tawkchat-iframe") || 
                        document.querySelector("[id^='tawk_']") || 
                        document.querySelector(".widget-visible"); // Fallback selectors
      setChatVisible(!!tawkWidget); // Set true if widget exists
    };

    // Initial check
    checkChatPresence();

    // Use MutationObserver to detect dynamic DOM changes
    const observer = new MutationObserver(checkChatPresence);
    observer.observe(document.body, { childList: true, subtree: true });

    // Cleanup observer on unmount
    return () => observer.disconnect();
  }, []);

  // Choose positioning class based on chat visibility
  const positionClass = chatVisible ? styles.scrollUpSupport : styles.scrollUpDefault;

  return (
    <button
      className={`${styles.scrollUpButton} ${positionClass} ${visible ? styles.visible : ""}`}
      onClick={scrollToTop}
      aria-label="Scroll to top"
    >
      <i className="fa fa-angle-up" aria-hidden="true"></i>
    </button>
  );
};

export default ScrollToTop;